'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import Script from 'next/script';
import { useJwtToken } from '@/app/_utils/session/use-jwt-token';
import { ChatbotPages } from './constants';
import { WindowWithChatbot } from './type';
import { ChatbotWidget } from './utils';
declare const window: WindowWithChatbot;
const ChatbotLoader = () => {
  const pathname = usePathname();
  const prevPathRef = useRef<string | null>(null);
  const {
    data,
    isLoading
  } = useJwtToken();
  const shouldLoadChatbot = ChatbotPages.some(regex => regex.test(pathname));
  useEffect(() => {
    const prevPath = prevPathRef.current;
    const wasChatbotPage = prevPath && ChatbotPages.some(regex => regex.test(prevPath));
    if (wasChatbotPage && !shouldLoadChatbot) {
      document.getElementById('floating-button')?.remove();
    }
    prevPathRef.current = pathname;
    if (shouldLoadChatbot && window.chatwidget && !isLoading) {
      ChatbotWidget.init(data ? data : null);
    }
  }, [pathname, isLoading, data, shouldLoadChatbot]);
  if (!shouldLoadChatbot) return null;
  return <Script id='chatbot-script' src={`${process.env.NEXT_PUBLIC_CHATBOT_API_URL}/widget/ArtinBotWidget.js`} onReady={() => {
    if (!isLoading) ChatbotWidget.init(data ? data : null);
  }} data-sentry-element="Script" data-sentry-component="ChatbotLoader" data-sentry-source-file="loader.tsx" />;
};
export default ChatbotLoader;